export default __webpack_public_path__ + "chef-cap2c3b08.png";